import config from "./global.config.json";

export const env = process.env.REACT_APP_DEV_ENV || process.env.NODE_ENV;

const apiConfig = config;

export const contentApiUrl = apiConfig[env].contentApi;
export const identityApiUrl = apiConfig[env].identityApi;
export const webPushApiUrl = apiConfig[env].webPushApi;
export const kenoIframeUrl = apiConfig[env].kenoIframe;
